import AsbestosInspection from './AsbestosInspection';
import ElectricalInspection from './ElectricalInspection';
import EnvironmentalInspection from './EnvironmentalInspection';
import HvacInspection from './HvacInspection';
import InsectInspection from './InsectInspection';
import LeasebasedPaintInspextion from './LeasebasedPaintInspextion';
import MoldInspection from './MoldInspection';
import PoolInspection from './PoolInspection';
import RadonInspection from './RadonInspection';
import RoofInspection from './RoofInspection';
import SewerInspection from './SewerInspection';
import StructureInspection from './StructureInspection';
import WaterInspection from './WaterInspection';

interface Props {
  additionalInspectionType?: string[];
  homeinspectionNegotiationDays?: number;
}

const AdditionalInspection = ({
  additionalInspectionType,
  homeinspectionNegotiationDays,
}: Props) => {
  const filteredInspections = (additionalInspectionType || []).filter(
    (item) => item !== 'No Additional Inspection Required'
  );

  if (filteredInspections.length === 0) {
    return (
      <div className="mb-6">
        <h2
          className="text-lg font-bold mb-4"
          style={{ fontSize: '14pt', fontWeight: 'bold' }}
        >
          ADDITIONAL INSPECTIONS
        </h2>
        <p>No Additional Inspection Required</p>
      </div>
    );
  }

  return (
    <div className="mb-6">
      <h2
        className="text-lg font-bold mb-4"
        style={{ fontSize: '14pt', fontWeight: 'bold' }}
      >
        ADDITIONAL INSPECTIONS
      </h2>
      {filteredInspections.map((inspectionType, idx) => (
        <div key={idx} className="mb-4">
          {inspectionType === 'Water' && (
            <WaterInspection
              homeinspectionNegotiationDays={homeinspectionNegotiationDays}
            />
          )}
          {inspectionType === 'Sewer' && (
            <SewerInspection
              homeinspectionNegotiationDays={homeinspectionNegotiationDays}
            />
          )}
          {inspectionType === 'Roof' && (
            <RoofInspection
              homeinspectionNegotiationDays={homeinspectionNegotiationDays}
            />
          )}
          {inspectionType === 'Insect' && (
            <InsectInspection
              homeinspectionNegotiationDays={homeinspectionNegotiationDays}
            />
          )}
          {inspectionType === 'Structure' && (
            <StructureInspection
              homeinspectionNegotiationDays={homeinspectionNegotiationDays}
            />
          )}
          {inspectionType === 'Environmental' && (
            <EnvironmentalInspection
              homeinspectionNegotiationDays={homeinspectionNegotiationDays}
            />
          )}
          {inspectionType === 'Radon' && (
            <RadonInspection
              homeinspectionNegotiationDays={homeinspectionNegotiationDays}
            />
          )}
          {inspectionType === 'Mold' && (
            <MoldInspection
              homeinspectionNegotiationDays={homeinspectionNegotiationDays}
            />
          )}
          {inspectionType === 'Lease-Based Paint' && (
            <LeasebasedPaintInspextion
              homeinspectionNegotiationDays={homeinspectionNegotiationDays}
            />
          )}
          {inspectionType === 'Asbestos' && (
            <AsbestosInspection
              homeinspectionNegotiationDays={homeinspectionNegotiationDays}
            />
          )}
          {inspectionType === 'Electrical' && (
            <ElectricalInspection
              homeinspectionNegotiationDays={homeinspectionNegotiationDays}
            />
          )}
          {inspectionType === 'HVAC' && (
            <HvacInspection
              homeinspectionNegotiationDays={homeinspectionNegotiationDays}
            />
          )}
          {inspectionType === 'Pool' && (
            <PoolInspection
              homeinspectionNegotiationDays={homeinspectionNegotiationDays}
            />
          )}
          {![
            'Water',
            'Sewer',
            'Roof',
            'Insect',
            'Structure',
            'Environmental',
            'Radon',
            'Mold',
            'Lease-Based Paint',
            'Asbestos',
            'Electrical',
            'HVAC',
            'Pool',
          ].includes(inspectionType) && (
            <div className="ml-4">
              <p>
                <strong>{inspectionType} Inspection Clause:</strong>
              </p>
              <p className="ml-4">
                The Buyer reserves the right to conduct a{' '}
                {inspectionType.toLowerCase()} inspection of the property within
                the specified timeframe. The results of this inspection may
                affect the terms of this contract.
              </p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default AdditionalInspection;
